var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('sc-page-loading'):_vm._e(),_vm._v(" "),_c('sc-analytics-status',{attrs:{"nameSpace":"statusReleasePayment","title":"Aguardando Liberação para Pagamento","rows":_vm.statusReleasePayment}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a969ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-status-release-payment/ScAnalyticsStatusReleasePayment.vue
// module id = null
// module chunks = 